import { ComponentStyles, defaultComponentStyles } from './componentStyles'
import { spacing } from './spacing'

export const auroraComponentStyles: ComponentStyles = {
  ...defaultComponentStyles,
  integratedBenefitsExplorer: {
    showEmbeddedFeaturedToolkit: false,
    showHeader: true,
    showMinimizedBannerDesign: false,
    showBenefitsAndCoverageSection: true,
  },
  integratedBenefitsEntryCard: {
    showBorder: false,
    paddingHorizontal: spacing['16px'],
    divider: {
      height: '1px',
    },
    shouldShowArrow: false,
    allowBackgroundColorOverride: false,
    showEmbeddedFeaturedToolkit: false,
  },
  compactImageCard: {
    useBodyText: false,
    shouldShowChevron: false,
    borderRadius: spacing['24px'],
    showBorder: false,
  },
  navBar: {
    useSmallBackButton: false,
    showBottomBorder: false,
  },
  inputField: {
    enableAiBorder: false,
    default: {
      borderRadius: 8,
      borderWidth: 1,
      paddingHorizontal: 16,
      paddingVertical: 12,
    },
    active: {
      borderWidth: 1.5,
      paddingHorizontal: 15.5,
      paddingVertical: 11.5,
    },
  },
  useFloatingCardsShadows: false,
  forkedTriage: {
    showCareOptionIllustration: false,
    useBoldTitleForMainCareOption: false,
    mainCareOptionCardCustomStyle: { border: '0px' },
  },
  illustrationBadge: {
    showBorder: false,
  },
}
